<template>
  <div>
    <in-text v-model="selectedItem.name" label="Nombre de Documento" p_icon="edit"/>
    <in-rq-ac :value.sync="selectedItem.critical_asset" :ae__state="[2]" p_icon="edit"/>
    <br>
    <fs1 tag="b">Área</fs1>
    <in-select :value.sync="selectedItem.organization" :items="organizations" p_icon="edit"/>
    <!-- <in_impacted_areas :value.sync="selectedItem.impacted_area" :chips="true" p_icon="edit" :single="true" :no_label="true"/> -->
    <!-- <div :a="report_datetime_format=!!selectedItem.id"></div> -->
    <in_date2 :value.sync="selectedItem.report_datetime" :check.sync="report_datetime_format"/>
    <!-- <div class="label_date">
      <v-checkbox style="margin-top:0" v-model="report_datetime_format"/>
      <b>Fecha</b>
      <fs1-tooltip :text="`El número de semana estará asociado al presente año (${current_year}). Adicionalente, estará vinculado al día lunes de la semana en cuestión.`"/>
    </div>
    <in-calendar v-if="report_datetime_format" :date.sync="selectedItem.report_datetime" :required="true"/>
    <in-select v-else :value.sync="select_report_datetime" :items="weeks" p_icon="edit"/> -->
    <br>
    <in-file-2  label="Archivo" :container="selectedItem" c_key="file" :on_add="upd"/>
    
    <br>
    <in-text v-model="selectedItem.link" label="Link Documento"/>
    <fs1 tag="p" style="color:darkred" v-if="selectedItem.link">La vinculación de documentos por medio de un link ignorará el archivo cargado en plataforma.</fs1>

  </div>
</template>

<script>
import in_date2 from './in_date2.vue';
import in_impacted_areas from '@/components/inputs/impacted_areas.vue';
const thisYear = new Date().getFullYear();
import { weeksInYear } from '@/functions/general.js';

export default {
  props:['selectedItem'],
  components:{in_impacted_areas,in_date2},
  data() {
    return {
      /* select_report_datetime:null, */
      current_year:0,
      report_datetime_format:true,
    };
  },
  watch:{
    /* select_report_datetime(){
      this.selectedItem.report_datetime = new Date();
      this.selectedItem.report_datetime.setFullYear = this.current_year;
    } */
  },
  computed:{
/* selectedItem_file_0(){ return this.selectedItem_file[0]}, */
    organizations(){return this.$store.getters.organizations},
    years() {
      const ys = [];
      for (let i = 2019; i < (thisYear+10); i++) ys.push(i);
      return ys;
    },
    weeks() {
      const ys = [];
      for (let i = weeksInYear(this.filter.f__year); i > 0; i--) ys.push(i);
      return ys;
    },
  },
  created(){ },
  methods:{
    upd(v,{file}){
      this.selectedItem.file = file;
      const d = file.name? file.name.split('.'):null;
      if (d) d.pop();
      const name = d? d.join('') : '';
      this.selectedItem.name = name;
    },
    /* getMondayFromWeekNum (weekNum, year) {
      const day = new Date(year, 0, (1 + (weekNum) * 7));
      while (day.getDay() !== 1) {//(1->lunes)
        day.setDate(day.getDate() - 1);
      }
      return day;
    }, */
  }
};
</script>

<style scoped>
.label_date>*{
  display: inline-block;
}
</style>
